import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Icon, SimpleModal } from '@livable/saas-react-components';
import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import useStyles from '../styles';
const ConfirmRemoveModal = _ref => {
  let bannerId = _ref.bannerId,
    isOpen = _ref.isOpen,
    removeNotification = _ref.removeNotification;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(isOpen),
    _useState2 = _slicedToArray(_useState, 2),
    modalIsOpen = _useState2[0],
    setModalIsOpen = _useState2[1];
  const defaultTrigger = /*#__PURE__*/React.createElement(Button, {
    onClick: () => setModalIsOpen(true),
    variant: "actionButton",
    className: classes.modalTrigger,
    'custom-attribute': '560-InformationBannersAddForm'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "delete"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('admin_page.remove_notification')));
  const handleOpenModal = () => setModalIsOpen(true);
  return /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: () => setModalIsOpen(false),
    handleOpen: handleOpenModal,
    isOpen: modalIsOpen,
    title: t('admin_page.confirm_removal'),
    trigger: defaultTrigger,
    rightButton: /*#__PURE__*/React.createElement(Button, {
      disabled: store.notifications.deleteSpecificNotificationsAsync.inProgress,
      onClick: () => removeNotification(bannerId),
      variant: "contained",
      'custom-attribute': '561-InformationBannersAddForm'
    }, t('admin_page.confirm_removal'))
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('admin_page.confirm_removal_text')));
};
export default ConfirmRemoveModal;